//website-client/src/utils/authErrors.js
export const WRONG_AUTH_METHOD_MESSAGES = {
  // google: 'This email is registered with Google. Please use Sign in with Google.',
  google: 'You signed up using a social account. Please continue with Google Sign in for your Alpherra account.',
  local: 'You didn’t register using a social account, so please use email-OTP Sign in for your Alpherra account.',
};

export function messageForWrongAuthMethod(existingProvider) {
  return WRONG_AUTH_METHOD_MESSAGES[existingProvider === 'google' ? 'google' : 'local'];
}

export function parseWrongAuthMethodResponse(body) {
  if (body?.code !== 'WRONG_AUTH_METHOD') return null;
  return {
    existingProvider: body.existingProvider,
    message: body.message || messageForWrongAuthMethod(body.existingProvider),
  };
}

const OAUTH_TOKEN_ERROR_RE = /invalid_grant|invalid_code_verifier|invalid code verifier/i;

export function messageForOAuthTokenFailure(err) {
  const msg = err?.message || String(err || '');
  if (OAUTH_TOKEN_ERROR_RE.test(msg)) {
    return 'Sign-in expired, please try again once.';
  }
  return msg || 'Google sign-in failed. Please try again.';
}
